import { FriendSection } from "@/types/friend";
import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const friendSections: FriendSection[] = [
  { key: "friends", title: "Friends", description: "Manage your friends" },
  { key: "followRequest", title: "Sent Request", description: "Requests you sent" },
  { key: "receivedRequest", title: "Received Request", description: "Incoming requests" },
  { key: "followed", title: "Following", description: "People you follow" },
  { key: "blockedList", title: "Blocked List", description: "Blocked users" },
];

export const maskString = (str?: string | null) => {
  if (!str) return "";
  if (str.length <= 4) return str; // no need to mask

  const visiblePart = str.slice(-4);              // last 4 characters
  const maskedPart = "*".repeat(str.length - 4);  // mask the rest

  return maskedPart + visiblePart;
}

export const sanitizeRichText = (htmlString: string | undefined) => {
  if (!htmlString) return "";
  // Allowed tags: <b>, <strong>, <i>, <em>, <u>, <br>, <p>
  const allowedTags = /<(\/?)(b|strong|i|em|u|br|p)>/gi;

  // Remove all **other** tags
  return htmlString.replace(/<\/?[^>]+>/gi, (tag) => {
    return tag.match(allowedTags) ? tag : "";
  });
}
